const state = {
  shouldShowEmailSupport: false
}

export default state
